import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { dismissNewManagement } from '../service';

export function useDismissNewManagement({
    onSuccess = () => {},
    onError = () => {},
}: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
} = {}) {
    const queryClient = useQueryClient();
    const toast = useToast();

    const mutation = useMutation({
        mutationFn: async ({
            agencyPortfolioPropertyId,
        }: {
            agencyPortfolioPropertyId: number;
        }) => {
            await dismissNewManagement(agencyPortfolioPropertyId);
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['integrated-properties'],
            });
            onSuccess();
        },
        onError: (error) => {
            toast({
                title: 'Failed to dismiss new management',
                description: `We experienced an error while trying to dismiss this property (${error.message})`,
                status: 'error',
                isClosable: true,
            });
            onError(error);
        },
    });

    return {
        isPending: mutation.isPending,
        isSuccess: mutation.isSuccess,
        dismissNewManagement: mutation.mutate,
    };
}
